import { render, staticRenderFns } from "./RoundInformation.vue?vue&type=template&id=3abf2c8b&scoped=true&"
import script from "./RoundInformation.vue?vue&type=script&lang=js&"
export * from "./RoundInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf2c8b",
  null
  
)

export default component.exports